import { render } from "./Gis.svg?vue&type=template&id=15ef3ce4"
const script = {}
script.render = render

export default script